module.exports = __webpack_public_path__ + "img/firewall-setting.cc1ac98 1.7a959d9.svg";